import { render, staticRenderFns } from "./OrganizationPagination.vue?vue&type=template&id=7a7f8670&scoped=true&"
import script from "./OrganizationPagination.vue?vue&type=script&lang=js&"
export * from "./OrganizationPagination.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationPagination.vue?vue&type=style&index=0&id=7a7f8670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7f8670",
  null
  
)

export default component.exports